import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import settings from './settings'
import event from './event'
import langs from './langs'
import customPages from './custom-pages'
import referralProgram from './referral-program'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    settings,
    event,
    langs,
    customPages,
    referralProgram,
  },
  state: {},
  mutations: {},
  actions: {},
})
